import some from 'lodash.some';
import { QUEUE_INCOMING, STATUS_OPEN } from '@chama/utils/constants/status';
import getFilteredDealerOrders from './get-filtered-dealer-orders';

const getSirenEnabled = state => {
  const orders = getFilteredDealerOrders(state);
  const {
    orderSound: { isSoundMuted },
  } = state;

  return (
    !isSoundMuted &&
    some(orders, ({ currentTicket }) => {
      const isTicketIncomingOrder = currentTicket.queue === QUEUE_INCOMING;
      const isTicketOpened = currentTicket.status === STATUS_OPEN;

      return isTicketIncomingOrder && isTicketOpened;
    })
  );
};

export default getSirenEnabled;



// WEBPACK FOOTER //
// ./src/selectors/get-siren-enabled.js